import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlayCircle,
  faBolt,
  faUsers,
  faChartLine,
  faMobileAlt,
} from '@fortawesome/pro-regular-svg-icons';
import './WelcomeWidget.css';
import StoreButtons from '../../../setup/SetupPage/SetupChecklist/StoreButtons';
import welcomeTileImage from '../../../../assets/welcome-tile-sensors.png';
import raTargetSmall from '../../../../assets/ra-target-small.png';

const DEFAULT_HOW_TOS = [
  { label: 'Get Started', href: 'https://avtech.com/articles/26160/', icon: faPlayCircle },
  { label: 'Add Users', href: 'https://avtech.com/articles/40/', icon: faUsers },
  { label: 'Create Alerts', href: 'https://avtech.com/articles/223/', icon: faBolt },
  { label: 'Graph Data', href: 'https://avtech.com/articles/21144/', icon: faChartLine },
];

const WelcomeWidgetView = ({
  context: {
    howTos = DEFAULT_HOW_TOS,
  },
  onRequestEditMode,
}) => (
  <div className="welcome-tile h-100 container-fluid py-3 px-3 px-md-4">
    <div className="row h-100 flex-nowrap align-items-center">

      {/* Product image */}
      <div className="welcome-tile__col welcome-tile__col--image">
        <img
          src={welcomeTileImage}
          alt="Room Alert"
          className="welcome-tile__product-img img-fluid"
        />
      </div>

      {/* Right side: title on top, then two columns (body + monitor) */}
      <div className="welcome-tile__col welcome-tile__col--content">
        <div className="welcome-tile__title-row">
          <img
            src={raTargetSmall}
            alt=""
            className="welcome-tile__target"
            aria-hidden="true"
          />
          <div className="welcome-tile__title-text">
            <div className="welcome-tile__welcome-to">
              Welcome
              <span className="welcome-tile__welcome-to--light"> to</span>
            </div>
            <div className="welcome-tile__title-line">
              <span className="welcome-tile__brand">Room Alert</span>
              <span className="welcome-tile__account"> Account</span>
            </div>
          </div>
        </div>

        <hr className="welcome-tile__divider" />

        <div className="welcome-tile__bottom">
          {/* Body: CTA + how-tos */}
          <div className="welcome-tile__body">
            <button
              type="button"
              onClick={onRequestEditMode}
              className="btn btn-link welcome-tile__cta"
            >
              Customize Your Dashboard
            </button>

            <h4 className="welcome-tile__howtos-heading">Helpful How To&apos;s</h4>
            <ul className="welcome-tile__howtos list-unstyled">
              {howTos.map((item) => (
                <li key={item.label} className="welcome-tile__howto-item">
                  <a href={item.href} className="welcome-tile__howto-link" rel="noopener noreferrer" target="_blank">
                    <FontAwesomeIcon icon={item.icon} className="welcome-tile__howto-icon" />
                    <span className="welcome-tile__howto-label">{item.label}</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Monitor From Anywhere + mobile store buttons */}
          <div className="welcome-tile__monitor">
            <h4 className="welcome-tile__monitor-heading">Monitor From Anywhere</h4>
            <div className="welcome-tile__download-link">
              <FontAwesomeIcon icon={faMobileAlt} className="welcome-tile__phone-icon" />
              <span>Download Mobile App</span>
            </div>
            <div className="welcome-tile__stores">
              <StoreButtons />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

WelcomeWidgetView.propTypes = {
  context: PropTypes.shape({
    dashboardHref: PropTypes.string,
    mobileAppHref: PropTypes.string,
    howTos: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      href: PropTypes.string,
      icon: PropTypes.object,
    })),
  }),
  onRequestEditMode: PropTypes.func,
};

WelcomeWidgetView.defaultProps = {
  context: {},
  onRequestEditMode: () => {},
};

export default WelcomeWidgetView;
